// my imports:
import * as Util from "@/app/lib/system/util";
import { PyramidGameState, PyramidSnapshot } from "@/app/lib/game-state/pyramid-game-state";
import { UserHistory } from "@/app/lib/ui/user-history";
import { StoryGameState, StorySnapshot } from "@/app/lib/game-state/story-game-state";
import { GameMode, isGameMode } from "@/app/lib/game-state/game-types";

// PYRAMID STATE / SNAPSHOT
// ----------------
export function savePyramidState(pyramid: PyramidGameState) {
    const snapshot: PyramidSnapshot = pyramid.exportSnapshot();
    localStorage.setItem(pyramid.version, JSON.stringify(snapshot));
}

export function retreivePyramidSnapshot(puzzleVersion: string) : PyramidSnapshot | null {
    const rawStringSnapshot = localStorage.getItem(puzzleVersion);
    if (!rawStringSnapshot)
        return null;
    const snapshot = JSON.parse(rawStringSnapshot);
    if (!PyramidGameState.isPyramidSnapshot(snapshot)) {
        Util.devLog(`attempted to retrieve snapshot for ${puzzleVersion} but type validation failed`);
        return null;
    }

    Util.devLog(`retrieved snapshot for ${snapshot.version}`)
    return snapshot;
}

// STORY STATE / SNAPSHOT
// -------------------------------------
// NOTE THAT WE SAVE AND RETREIVE VIA **levelID**
export function saveStoryState(storyState: StoryGameState) {
    const snapshot: StorySnapshot = storyState.exportSnapshot();
    localStorage.setItem(storyState.levelID, JSON.stringify(snapshot));
    console.log(snapshot);
    Util.devLog(`saving story state for ${storyState.levelID}`)
}

export function retrieveStorySnapshot(levelID: string) : StorySnapshot | null {
    const rawStringSnapshot = localStorage.getItem(levelID);
    if (!rawStringSnapshot)
        return null;
    const snapshot = JSON.parse(rawStringSnapshot);
    if (!StoryGameState.isStorySnapshot(snapshot)) {
        Util.devLog(`attempted to retrieve snapshot for ${levelID} but type validation failed`);
        return null;
    }

    Util.devLog(`retrieved snapshot for ${snapshot.levelID}`)
    return snapshot;
}


// HISTORY
// ---------------------------------------------
const defaultHistoryKey: string = 'userHistory'
export function saveHistory(history: UserHistory, key: string = defaultHistoryKey) {
    localStorage.setItem(key, history.exportJSON());
}

export function retrieveHistory(key: string = defaultHistoryKey): UserHistory {
    let storedHistory = localStorage.getItem(key);
    if (!storedHistory) {
        return new UserHistory();
    }
    return new UserHistory().importJSON(storedHistory);
    
}

// LAST VISITED GAME MODE
const defaultLastVisitedGameModeKey: string = 'lastVisitedMode';
export function saveLastVisitedGameMode(mode: GameMode, key: string = defaultLastVisitedGameModeKey) {
    localStorage.setItem(key, mode);
}
export function retrieveLastVisitedGameMode(key = defaultLastVisitedGameModeKey) : GameMode | null {
    const lastVisitedGameMode = localStorage.getItem(key);
    if (
        !lastVisitedGameMode
        || !isGameMode(lastVisitedGameMode)
    ) {
        return null;
    }
    return lastVisitedGameMode;
}

// LAST VISITED LEVEL
// -------------------------------------------------------
const defaultLastVisitedLevelKey: string = 'lastVisitedLevel';
export function saveLastVisitedLevelID(levelID : string, key: string = defaultLastVisitedLevelKey) {
    localStorage.setItem(key, levelID);
}
export function retrieveLastVisitedLevelID(key = defaultLastVisitedLevelKey) : string | null{
    const levelID = localStorage.getItem(key);
    if (!levelID) {
        return null;
    }
    return levelID;
}


// STREAK IS NOW IN HISTORY
const defaultStreakKey: string = 'streak';
export function saveStreak(count: number, key: string = defaultStreakKey) {
    localStorage.setItem(key, JSON.stringify(count));
}

export function retrieveStreak(key: string = defaultStreakKey) : number {
    let countString = localStorage.getItem(key);
    if (!countString) {
        // make the entry
        saveStreak(0);
        return 0;
    }
    return JSON.parse(countString);
}